import { lazy, Suspense } from "react";
import { Outlet } from "react-router";
import styles from "./styles.module.scss";
import { useIsMobile } from "@/common/hooks/useIsMobile";
import { useScrollToTop } from "@/common/hooks/useScrollToTop";
import { ModalError } from "@/components/ModalError";
import { Header } from "@/widgets/Header";
import MobileLayout from "@/widgets/Layout/Cabinet/mobile";

const DesktopLayout = lazy(
  () => import(/* webpackChunkName: "desktop-cabinet-layout" */ "./desktop"),
);

export const LayoutCabinet = () => {
  useScrollToTop();
  const token = localStorage.getItem("token");
  const isMobile = useIsMobile();
  return (
    <>
      <Header showButton={!token} />
      <main className={styles.main}>
        {isMobile && (
          <MobileLayout>
            <Outlet />
          </MobileLayout>
        )}
        {!isMobile && (
          <Suspense fallback={null}>
            <DesktopLayout>
              <Outlet />
            </DesktopLayout>
          </Suspense>
        )}
      </main>
      <ModalError />
    </>
  );
};
